export class MetaTagConstants {
    public static title = 'Forever Living Products';
    public static metaTitle = 'Forever Living Products';
// tslint:disable-next-line: max-line-length
    public static metaDescription = 'Forever Living is the world’s largest grower, manufacturer and distributor of Aloe Vera. Discover Forever Living Products and learn more about becoming a forever business owner here.';
}
